import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { MenuItem, Carousel } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';

import Layout from '../layout';
import StoreTile from '../store-tile';
import StoreCard from '../store-card';

import styles from '../styles/pages/show-stores.scss';
import loadingStyles from '../styles/components/loading.scss';

const getProperties = () => {
    const width = document.documentElement.clientWidth;
    const bordersWidth = 0.14 * width;

    if (width > 400) {
        return {
            marginLeft: '50px',
            cantInCorousel: Number.parseInt((width - (2 * bordersWidth)) / 250, 10),
            height: '100px',
        };
    }

    return {
        marginLeft: '25px',
        cantInCorousel: Number.parseInt((width - (2 * bordersWidth)) / 200, 10),
        height: '50px',
    };
};

const StorePage = (props) => {
    const getZone = () => props.availableZones.find((zone) => zone.id === props.currentZone).name;

    const [selectedText, setSelectedText] = useState(getZone());
    const [selectedZoneId, setSelectedZoneId] = useState(props.currentZone || 6);
    const [properties, setProperties] = useState({ ...getProperties() });
    const [limit, setLimit] = useState(15);
    const [page, setPage] = useState(1);

    window.addEventListener('resize', () => {
        setProperties({ ...getProperties() });
    });

    useEffect(() => {
        props.setCurrentZone(selectedZoneId, page, limit);
    }, [page]);

    const setSelected = (id, name) => {
        setSelectedText(name);
        setSelectedZoneId(id);
        setPage(1);
        props.setCurrentZone(id, page);
    };

    const getFormatedList = (groupLength) => {
        let result = [];
        let group = [];

        for (let i = 0; i < props.stores.length; i += 1) {
            if (i === 0 || i % groupLength !== 0) group = [...group, props.stores[i]];
            else {
                result = [...result, group];
                group = [props.stores[i]];
            }
        }

        if (group !== []) result = [...result, group];
        return result;
    };

    return (
        <Layout>
            <div>
                <img className={styles.headerBanner} src={require('../../images/carousel/en/image01.jpg')} alt="banner" />
            </div>
            <div className={styles.container}>
                <div className={styles.storesContainer}>
                    <div className={styles.zoneSelector}>
                        <DropdownButton id="dropdown-basic-button" as="button" className={`button-cancel ${styles.zoneSelectorButton}`} title={selectedText}>
                            {props.availableZones.map((zone) => (
                                <MenuItem as="button" className="button-secondary inv button-small" id={zone.id} key={zone.id} onClick={() => setSelected(zone.id, zone.name)}>{zone.name}</MenuItem>
                            ))}
                        </DropdownButton>
                    </div>
                </div>
                {/* <div className={styles.mostVisitedContainer}>
                    <div>
                        <h1 className={styles.mostVisitedHeader}>
                            <FormattedMessage
                                id="mostVisited"
                                defaultMessage="Most visited stores"
                            />
                        </h1>
                    </div>
                    <div className={styles.mostVisitedStores}>
                        <Carousel indicators={false}>
                            {props.stores && getFormatedList(8).map((storeList, idx) => (
                                <Carousel.Item
                                    key={idx}
                                    style={{ alignItems: 'center', cursor: 'pointer', padding: '0 130px' }}
                                >
                                    {storeList.map((store) => (
                                        <Link to={`/${store.code}`} key={store.id} style={{ display: 'inline-block' }}>
                                            <StoreTile
                                                name={store.name}
                                                styles={styles.storeTile}
                                                logo={store.logo_file_name}
                                            />
                                        </Link>
                                    ))}
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </div>
                                    </div> */}
                <div className={styles.allStoresContainer}>
                    <div>
                        <h1 className={styles.allStoresHeader}>
                            <FormattedMessage
                                id="allStores"
                                defaultMessage="All the stores"
                            />
                        </h1>
                    </div>
                    <div className={styles.allStoresWrapper}>
                        {props.displayLoader && (
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                <div>
                                    <h4 className={styles.loadingText}>
                                        <FormattedMessage id="loading-stores" defaultMessage="Loading stores" />
                                        <span className="hidden-xs">
                                            {', '}
                                            <FormattedMessage id="please-wait" defaultMessage="please wait" />
                                        </span>
                                        ...
                                    </h4>
                                    <div className={loadingStyles.spinnerDark} />
                                </div>
                            </div>
                        )}
                        {
                            !props.displayLoader && props.storesByZone && props.storesByZone.map((store) => (
                                <Link to={`/${store.code}`} key={store.id}>
                                    <StoreCard name={store.name} styles={styles} logo={store.logo_file_name} description={store.description} />
                                </Link>
                            ))
                        }
                    </div>
                    <div className={styles.paginatorBottomContainer}>
                        <div className={styles.paginatorInfo}>
                            <span>
                                <FormattedMessage id="paginator-sentence-1" defaultMessage="Showing" />
                                {` ${(page * limit) < 19 ? page * props.storesByZone.length : 19} `}
                                <FormattedMessage id="paginator-sentence-2" defaultMessage="of" />
                                {` ${19} `}
                                <FormattedMessage id="paginator-sentence-3" defaultMessage="results" />
                            </span>
                        </div>
                        <ReactPaginate
                            previousLabel="previous"
                            nextLabel="next"
                            breakLabel="..."
                            breakClassName="break-me"
                            pageCount={props.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(data) => setPage(data.selected + 1)}
                            containerClassName="pagination"
                            activeClassName="active"
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default injectIntl(StorePage);



/** WEBPACK FOOTER **
 ** ./src/components/pages/show-stores.jsx
 **/